import React, { Component } from 'react';
import { Button } from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

export class PricingPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localPriceObject: null,
    };
  }

  componentDidMount = () => {
    if (this.props.nativeMode) return;
    if (window.Paddle?.Product?.Prices) this.getLocalPrice();
    else {
      window.addEventListener('betareader:paddle-ready', this.getLocalPrice);
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('betareader:paddle-ready', this.getLocalPrice);
  };

  getLocalPrice = async () => {
    const { pricingPlan } = this.props;
    if (!window.Paddle?.Product?.Prices) return;
    window.removeEventListener('betareader:paddle-ready', this.getLocalPrice);
    if (pricingPlan.externalId !== 'free') {
      try {
        await window.Paddle.Product.Prices(
          pricingPlan.externalId,
          priceObject => {
            this.setState({
              localPriceObject: priceObject,
            });
          }
        );
      } catch (e) {
        console.log('error', e);
      }
    }
  };

  render() {
    const {
      isCurrentPricingPlan,
      pricingPlan,
      t,
      hideButton,
      isCancelled,
      validUntilDate,
      isLoggedIn,
      nativeMode,
      nativePrice,
      purchasePending,
      purchaseInProgress,
    } = this.props;
    const { localPriceObject } = this.state;
    let disabledButton = isCurrentPricingPlan;
    let buyButtonVariant = 'primary';
    let buyButtonText = t('BuyNow');
    let localPrice = '';
    let subscriptionType = '';
    // set the local price once we get it from paddle.js
    if (localPriceObject) {
      localPrice = localPriceObject.price.gross;
      subscriptionType = `/ ${t(localPriceObject.recurring.subscription.type)}`;
    }
    if (nativeMode && pricingPlan.externalId !== 'free') {
      localPrice = nativePrice || t('Unavailable', 'Unavailable');
      subscriptionType = `/ ${t(pricingPlan.billingInterval)}`;
      disabledButton = disabledButton || !nativePrice;
    }
    // if we have a free plan override instead with "free message"
    if (pricingPlan.externalId === 'free') {
      localPrice = 'Zero';
      subscriptionType = `${t('NoCreditCardNeeded')}`;
    }
    // set the button color to grey if disabled and on lower plans
    if (disabledButton) {
      buyButtonVariant = 'secondary';
    }
    //  set the button Text to GoFree on free plans
    if (pricingPlan.externalId === 'free') {
      if (isLoggedIn && !isCurrentPricingPlan) {
        // if logged in and not on free: downgrade
        buyButtonText = t('Downgrade');
      } else {
        // not logged in
        buyButtonText = t('SignIn');
      }
    }
    // override colors and text for current pricingPlan with orange and current text
    if (isCurrentPricingPlan) {
      buyButtonVariant = 'secondary';
      buyButtonText = t('Current');
    }
    if (purchaseInProgress) {
      disabledButton = true;
    }
    if (pricingPlan) {
      return (
        <div className="subscription-pricing-plan">
          <div className="subscription-pricing-plan__price" style={{ minHeight: !hideButton ? 100 : undefined }}>
            <strong>{localPrice}</strong>
            <span>{subscriptionType}</span>
          </div>
          {!hideButton && (
            <div className="subscription-pricing-plan__action">
              <Button
                variant={buyButtonVariant}
                disabled={disabledButton}
                aria-busy={Boolean(purchasePending)}
                className="product-buy-button"
                onClick={() => this.props.onPress(pricingPlan, localPriceObject)}
              >
                {purchasePending && <span className="subscription-pricing-plan__spinner" aria-hidden="true" />}
                {buyButtonText.toUpperCase()}
              </Button>
              {isCancelled && validUntilDate && (
                <span className="subscription-pricing-plan__valid-until">
                  {t('ValidUntil')}: {moment(validUntilDate).format('L')}
                </span>
              )}
            </div>
          )}
        </div>
      );
    }
    return null;
  }
}

export default withTranslation()(PricingPlan);
